"use strict";

/******************************************************
 *    Directive pour afficher les informations sur un point d'arrêt
 ********************************************************/

angular.module("app").directive("tchStopPointInfoAdd", ["$http", "ENV", function ($http, ENV) {
	return {
		restrict: "E",
		templateUrl: "common/directives/exploitation/tchStopPointInfo/tchStopPointInfoAdd.html",
		replace: false,
		scope: {
			boardingId: "=",
			callback: "&clickButtonCallback"
		},
		link: function (scope, elt, attrs) {
			scope.loading = true;
			$http.get(ENV.API_URL + "/stop-areas/boarding/" + scope.boardingId + "/route-structure")
				.then((response) => {
					scope.loading = false;
					scope.data = response.data;
				}).catch(() => scope.loading = false);

			scope.buttonClicked = function () {
				scope.callback({
					stoppoint: scope.boardingId
				});
			};

		}

	};
}])
;
